export default __webpack_public_path__ + "static/media/Deepak Prasad.c1c3c6a5.jpg";